import {
  IUpdateDestinations,
  TOGGLE_LOADING_DESTINATIONS,
  UPDATE_DESTINATIONS,
  IToggleLoadingDestinations,
} from './types';

export function updateDestinationsAction(
  actionData: IUpdateDestinations['actionData'],
): IUpdateDestinations {
  return {
    type: UPDATE_DESTINATIONS,
    actionData,
  };
}

export function toggleLoadingDestinationsAction(
  actionData: IToggleLoadingDestinations['actionData'],
): IToggleLoadingDestinations {
  return {
    type: TOGGLE_LOADING_DESTINATIONS,
    actionData,
  };
}
